/**
 * Each event name should be used with an `event` tag,
 * which validates the value and prevents incorrect names.
 */
import { event } from 'shared/experiments/utils/event'

export const CSW_PRODUCT_CLICK = event`Click on product of CSW`
export const CSW_CLICK_ADD_TO_CART = event`Click on add to cart button on CSW`
export const CSW_SHOW_MORE_CLICK = event`Click on show more button of CSW`
export const CSW_SHOW_ALL_CLICK = event`Click on show all button of CSW`
export const CSW_ARROW_CLICK = event`Click on arrow of CSW`

export const SERP_PRODUCT_DETAIL_CLICK = event`SERP - Click on product detail link`
export const HOME_SERVICE_LINK_CLICK = event`Click on service link`
export const SERP_FILTER_APPLY = event`SERP - Apply filter`
export const SERP_PAGINATION = event`SERP - Pagination`
export const SERP_ADD_TO_CART_CLICK = event`SERP - Click on add-2-cart CTA`

export const EVENT_CLICK_ON_PRODUCT_VARIANT = event`NEW SERP - Click on product variant`
export const EVENT_CLICK_ADD_TO_CART = event`NEW SERP - Click on add-2-cart CTA`
export const EVENT_CLICK_ON_PRODUCT_DETAIL = event`NEW SERP - Click on product detail link`

export const PDP_ADD_TO_CART = event`PDP - Click on add-2-cart CTA`
export const DRAWER_ADD_TO_CART = event`Drawer - Click on add-2-cart CTA`
export const PDP_CLICK_ON_VARIANT = event`PDP - Click on variant`
export const PDP_CLICK_ON_APPLY = event`PDP - Click on apply`

export const CART_CHECKOUT_BUTTON_CLICK = event`Cart - Click on checkout button`
export const CART_REMOVE_PRODUCT_CLICK = event`Cart - Click on remove product button`
export const CART_VOUCHER_SUBMIT_CLICK = event`Cart - Click on voucher submit button`
export const CART_VOUCHER_INPUT_CLICK = event`Cart - Click on voucher input`

export const PDP_ODS_MODAL_BOX = event`ods-pdp-modal`
export const PDP_ODS_MODAL_BOX_NEARBY = event`ods-pdp-modal-nearby`
export const PDP_ODS_MODAL_BOX_OPEN = event`ods-pdp-modal-open`
export const PDP_ODS_MODAL_REQUEST_RX = event`ods-pdp-modal-request-rx`

export const MOBILE_APP_APP_STORE_CLICK = event`Mobile App - Click on App Store`
export const MOBILE_APP_GOOGLE_STORE_CLICK = event`Mobile App - Click on Google Play`
export const MOBILE_APP_HUAWEI_STORE_CLICK = event`Mobile App - Click on Huawei Store`

export const HEADER_SEARCH_BOX_CLICK = event`HEADER - Click on search box`
export const HEADER_SEARCH_BOX_SUGGESTED_PRODUCT_CLICK = event`HEADER - Click on suggested search box product`
export const HEADER_SEARCH_BOX_SUGGESTED_PRODUCT_ADD_TO_CART = event`HEADER - Suggested search box product added to cart`
export const HEADER_SEARCH_BUTTON_CLICK = event`HEADER - Click on search button`
export const HEADER_NOTEPAD_ICON_CLICK = event`HEADER - Click notepad icon`
export const HEADER_NOTEPAD_LINK_CLICK = event`HEADER - Click notepad link`
export const HEADER_LOGIN_ICON_CLICK = event`HEADER - Click login icon`
export const HEADER_MY_APOTHEKE_ICON_CLICK = event`HEADER - Click my apotheke icon`
export const HEADER_CART_ICON_CLICK = event`HEADER - Click on cart icon`
export const HEADER_CATEGORIES_HOVER = event`HEADER - Mouse over categories`
export const HEADER_PRODUCTS_HOVER = event`HEADER - Mouse over products`
export const HEADER_SEARCH_ICON_CLICK = event`HEADER - Click on search icon`
export const HEADER_MOBILE_BURGER_MENU_CLICK = event`HEADER - Click on mobile burger menu`
export const HEADER_REDEEM_PRESCRIPTION_CLICK = event`HEADER - Click on redeem prescription`

export const CAT_ADD_TO_CART_CLICK = event`CAT - Click on add-2-cart CTA`

export const CART_GOT_ELIGIBLE_BY_DELETE = event`CART_GOT_ELIGIBLE_BY_DELETE`
export const CART_GOT_ELIGIBLE_BY_QUANTITY_CHANGE = event`CART_GOT_ELIGIBLE_BY_QUANTITY_CHANGE`
export const NOW_CART_LABEL_CLICK = event`NOW_CART_LABEL_CLICK`
export const NOW_CART_COLLAPSIBLE_CHECK_ELIGIBILITY_BTN_CLICK = event`NOW_CART_CHECK_ELIGIBILITY_BTN_CLICK`
export const NOW_CART_COLLAPSIBLE_CHANGE_ZIPCODE_BTN_CLICK = event`NOW_CART_COLLAPSIBLE_CHANGE_ZIPCODE_BTN_CLICK`
export const NOW_CART_GO_CHECKOUT_BTN_CLICK = event`NOW_CART_GO_CHECKOUT_BTN_CLICK`

export const NOW_SERP_LABEL_CLICK = event`NOW_SERP_LABEL_CLICK`
export const NOW_VALID_PLZ = event`NOW_VALID_PLZ`
export const NOW_INVALID_PLZ = event`NOW_INVALID_PLZ`
export const NOW_PDP_GLB_CLICK = event`NOW_PDP_GLB_CLICK`
export const NOW_PDP_LABEL_CLICK = event`NOW_PDP_LABEL_CLICK`
export const NOW_PDP_BUYBOX_TIMER_CLICK = event`NOW_PDP_BUYBOX_TIMER_CLICK`
export const NOW_CATEGORY_GLB_CLICK = event`NOW_CATEGORY_GLB_CLICK`
export const NOW_HOMEPAGE_GLB_CLICK = event`NOW_HOMEPAGE_GLB_CLICK`
export const NOW_SERP_GLB_CLICK = event`NOW_SERP_GLB_CLICK`
export const NOW_PDP_SHIPPING_MODAL_SUBMIT = event`NOW_PDP_SHIPPING_MODAL_SUBMIT`
export const NOW_SERP_GLB_MODAL_SUBMIT = event`NOW_SERP_GLB_MODAL_SUBMIT`
export const NOW_PDP_GLB_MODAL_SUBMIT = event`NOW_PDP_GLB_MODAL_SUBMIT`
export const NOW_CATEGORY_GLB_MODAL_SUBMIT = event`NOW_CATEGORY_GLB_MODAL_SUBMIT`
export const NOW_HOMEPAGE_GLB_MODAL_SUBMIT = event`NOW_HOMEPAGE_GLB_MODAL_SUBMIT`
export const NOW_CATEGORY_LABEL_CLICK = event`NOW_CATEGORY_LABEL_CLICK`
export const NOW_SERP_SHIPPING_MODAL_SUBMIT = event`NOW_SERP_SHIPPING_MODAL_SUBMIT`
export const NOW_CATEGORIES_SHIPPING_MODAL_SUBMIT = event`NOW_CATEGORIES_SHIPPING_MODAL_SUBMIT`
export const SPECIAL_SALE_OFFERS_MODAL_CLICK = event`Click on modal button`
export const SPECIAL_SALE_OFFERS_PRODUCT_IN_MODAL_CLICK = event`Click on product of modal`

export const SEARCH_BOX_QUERY_SUGGESTION_CLICK = event`SearchBox - Click on popular query suggestion`
export const SEARCH_BOX_QUERY_HISTORY_CLICK = event`SearchBox - Click on query history`
export const SEARCH_BOX_CLEAN_HISTORY_CLICK = event`SearchBox - Click on history delete`
export const SEARCH_BOX_SUGGESTED_BRAND_CLICK = event`SearchBox - Click on brand suggestion`
export const SEARCH_BOX_SUGGESTED_CATEGORY_CLICK = event`SearchBox - Click on category suggestion`
export const SEARCH_BOX_SUGGESTED_PRODUCT_CLICK = event`SearchBox - Click on suggested product`
export const SEARCH_BOX_SHOW_ALL_RESULTS_BUTTON_CLICK = event`SearchBox - Click on show all results`
export const ACCOUNT_OVERVIEW_DOWNLOAD_INVOICE = event`Account Overview - Click on download invoice`
export const ACCOUNT_OVERVIEW_HELP_WITH_MY_ORDER = event`Account Overview - Click on help with my order`
export const ACCOUNT_OVERVIEW_LAST_ORDER_DETAIL = event`Account Overview - Click on last order detail`
